import React from 'react';
import classes from './Header.module.css';

const Header = () => {

    return (
        <div className={classes.header}>
            <h2>Add your To-Do here.</h2>
        </div>
    )
};

export default Header;